<div fxLayout="row" fxLayoutAlign="center center" class="pt-xs">
	<span style="padding: 0 8px; color: var(--dark-gray)">|</span>
	<button
		mat-button
		id="{{ breadcrumbItem.menuItem?.menuItemId }}-button"
		attr.aria-label="Breadcrumb-{{ getMenuTitle(breadcrumbItem.menuItem) }}"
		style="padding: 0px; min-width: 0; border-radius: 0px"
		[ngClass]="isActive ? 'active-item' : 'inactive-item'"
		[matMenuTriggerFor]="menu"
		*ngIf="!breadcrumbItem.isInput"
	>
		{{ getMenuTitle(breadcrumbItem.menuItem) }}
		<fa-icon [icon]="$any(breadcrumbItem.menuItem?.icon)" *ngIf="breadcrumbItem.menuItem?.icon"></fa-icon>
	</button>

	<mat-form-field
		*ngIf="breadcrumbItem.isInput"
		class="breadcrumb-form-field"
		appearance="outline"
		subscriptSizing="dynamic"
	>
		<mat-label> Select Breadcrumb </mat-label>
		<mat-select id="breadcrumb-select">
			@for (selection of breadcrumbItem.parentMenu; track selection) {
				<mat-option
					(onSelectionChange)="menuNavigate(selection)"
					attr.aria-label="Breadcrumb-{{ selection.title }}"
				>
					{{ getMenuTitle(selection) }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>

	<mat-menu #menu="matMenu">
		<div
			id="{{ breadcrumbItem.menuItem?.menuItemId }}-menu-dropdown"
			class="dropdown-container"
			*ngIf="breadcrumbItem.parentMenu"
			style="color: var(--dark-gray); padding-left: 8px; padding-top: 8px"
		>
			<div *ngFor="let selection of breadcrumbItem.parentMenu" style="margin-bottom: 8px !important">
				<div
					mat-menu-item
					(click)="menuNavigate(selection)"
					(keydown.enter)="menuNavigate(selection)"
					(keydown.space)="menuNavigate(selection)"
					tabindex="0"
				>
					{{ getMenuTitle(selection) }}
				</div>
			</div>
		</div>
	</mat-menu>
</div>
